"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GeodesPreview30_exports = {};
__export(GeodesPreview30_exports, {
  default: () => GeodesPreview30_default
});
module.exports = __toCommonJS(GeodesPreview30_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.6602 7.88672C14.6602 9.03255 14.3411 9.97005 13.7031 10.6992C13.0651 11.4284 12.2188 11.793 11.1641 11.793H8.64453V15.8359C8.64453 16.0182 8.58594 16.1745 8.46875 16.3047C8.36458 16.4349 8.22786 16.5 8.05859 16.5H6.90625C6.75 16.5 6.61328 16.4349 6.49609 16.3047C6.39193 16.1745 6.33984 16.0182 6.33984 15.8359V4.66406C6.33984 4.48177 6.39193 4.32552 6.49609 4.19531C6.61328 4.0651 6.75 4 6.90625 4H11.1641C12.2188 4 13.0651 4.37109 13.7031 5.11328C14.3411 5.84245 14.6602 6.76693 14.6602 7.88672ZM8.64453 6.30469V9.58594H10.9102C11.3529 9.58594 11.7044 9.4362 11.9648 9.13672C12.2253 8.83724 12.3555 8.44661 12.3555 7.96484C12.3555 7.44401 12.2253 7.04036 11.9648 6.75391C11.7044 6.45443 11.3529 6.30469 10.9102 6.30469H8.64453Z",
      fill: "currentColor"
    }
  )
);
const SvgGeodesPreview30 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var GeodesPreview30_default = SvgGeodesPreview30;
